import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-reporting-fields',
  templateUrl: './reporting-fields.component.html',
  styleUrls: ['./reporting-fields.component.css'],
  standalone: false
})
export class ReportingFieldsComponent {
  /** The shared vm object (provides rfType, rf1–rf5, location). */
  @Input() vm: any;
  /**
   * Optional detail row target. When provided, binds rf_id_1–rf_id_5 and
   * location_id on the detail row (line-item mode). When absent, binds
   * rf_id_0–rf_id_4 on vm.item.header (header mode).
   */
  @Input() target: any = null;
}
